<template>
  <div id="suitCell">
    <div id="cellDiv" >
      <a v-on:click="callSuit()">
        <Card class="card" :cardId="cardName" :disabled="disabled || clicked" />
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Card from "@/components/Card";

export default {
  name: "SuitCell",
  components: {
    Card
  },
  props: {
    cardName: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      clicked: false
    };
  },
  computed: {
    ...mapGetters({ 
      callSection: "call/callSuit",
    })
  },
  methods: {
    callSuit() {
      this.clicked = true;
      let payload = {
        card: this.cardName
      }
      this.$store.dispatch("call/callSuit", payload).then(() => {
        this.clicked = false;
      });
    }
  }
};
</script>
<style scoped>
#cellDiv {
  cursor: pointer;
}
</style>
